import { client } from "@nju/http-client";
import { serverResponse } from "./validators";

export async function getSetSimDigits(orderId: string | undefined) {
  const result = await client(
    `${process.env.NEXT_PUBLIC_HELPERS}/orders/${orderId}/iccid`,
    {
      headers: {
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      validator: serverResponse,
    },
  );

  return result;
}
